<script>
export default {
	name: 'IconSvgUrl',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_66_353)">
				<path
					d="M13.4776 4.104C13.0129 4.10356 12.5674 3.92237 12.2388 3.60023C11.9102 3.27809 11.7254 2.8413 11.7249 2.38572V1.54872e-07H3.89429C3.59386 -0.000109302 3.29634 0.0578014 3.01874 0.170444C2.74114 0.283086 2.48889 0.44825 2.27641 0.656487C2.06393 0.864725 1.89538 1.11196 1.78038 1.38408C1.66539 1.65619 1.6062 1.94785 1.6062 2.2424V15.7602C1.6062 16.0547 1.66539 16.3464 1.78038 16.6185C1.89538 16.8906 2.06393 17.1379 2.27641 17.3461C2.48889 17.5543 2.74114 17.7195 3.01874 17.8321C3.29634 17.9448 3.59386 18.0027 3.89429 18.0026H13.2948C13.9014 18.0026 14.4832 17.7663 14.9121 17.3458C15.3411 16.9253 15.582 16.3549 15.582 15.7602V4.104H13.4776Z"
					:fill="color" />
				<path
					d="M7.55913 12.3271H6.96383C6.53944 12.2638 6.14347 12.066 5.83639 11.7589C5.45843 11.381 5.24609 10.8683 5.24609 10.3338C5.24609 9.79932 5.45843 9.2867 5.83639 8.90874L6.59789 8.14724C6.7541 7.99103 7.00736 7.99103 7.16357 8.14724C7.31978 8.30345 7.31978 8.55672 7.16357 8.71293L6.40207 9.47442C6.17414 9.70235 6.04609 10.0115 6.04609 10.3338C6.04609 10.6562 6.17414 10.9653 6.40207 11.1932C6.63 11.4212 6.93914 11.5492 7.26148 11.5492C7.58382 11.5492 7.89296 11.4212 8.12089 11.1932L8.88238 10.4317C9.03859 10.2755 9.29186 10.2755 9.44807 10.4317C9.60428 10.5879 9.60428 10.8412 9.44807 10.9974L8.68657 11.7589C8.37949 12.066 7.98352 12.2638 7.55913 12.3271Z"
					fill="#4F89D5" />
				<path
					d="M9.06732 6.80918C9.29525 6.58125 9.60439 6.4532 9.92673 6.4532C10.2491 6.4532 10.5582 6.58125 10.7861 6.80918C11.0141 7.03711 11.1421 7.34624 11.1421 7.66858C11.1421 7.99092 11.0141 8.30006 10.7861 8.52799L10.0246 9.28949C9.86842 9.4457 9.86842 9.69897 10.0246 9.85517C10.1808 10.0114 10.4341 10.0114 10.5903 9.85517L11.3518 9.09368C11.7298 8.71572 11.9421 8.2031 11.9421 7.66858C11.9421 7.13407 11.7298 6.62145 11.3518 6.24349C10.9739 5.86553 10.4612 5.6532 9.92673 5.6532C9.39221 5.6532 8.87959 5.86553 8.50164 6.24349L7.74014 7.00499C7.58393 7.1612 7.58393 7.41447 7.74014 7.57068C7.89635 7.72689 8.14961 7.72689 8.30582 7.57068L9.06732 6.80918Z"
					fill="#4F89D5" />
				<path
					d="M10.0038 8.15715C10.1601 8.00094 10.1601 7.74767 10.0038 7.59146C9.84764 7.43525 9.59437 7.43525 9.43816 7.59146L7.20816 9.82147C7.05195 9.97768 7.05195 10.2309 7.20816 10.3872C7.36437 10.5434 7.61763 10.5434 7.77384 10.3872L10.0038 8.15715Z"
					fill="#4F89D5" />
				<path
					d="M15.5821 4.104H13.4776C13.0129 4.10355 12.5674 3.92237 12.2388 3.60023C11.9102 3.27809 11.7254 2.8413 11.725 2.38572V0L15.5821 4.104Z"
					fill="#4F89D5" />
				<path
					d="M17.2412 14.2169H6.61332C5.85944 14.2169 5.24829 14.8161 5.24829 15.5552V18.6617C5.24829 19.4008 5.85944 20 6.61332 20H17.2412C17.9951 20 18.6062 19.4008 18.6062 18.6617V15.5552C18.6062 14.8161 17.9951 14.2169 17.2412 14.2169Z"
					fill="#4F89D5" />
				<path
					d="M13.1007 18.3489L12.5473 17.4023H12.4063V18.3489H11.7883V15.8432H12.844C13.0197 15.8385 13.1943 15.8736 13.354 15.9457C13.485 16.0068 13.5945 16.1049 13.6684 16.2273C13.7396 16.3526 13.7757 16.494 13.773 16.6373C13.778 16.8048 13.7236 16.9688 13.6191 17.1015C13.5053 17.2362 13.3478 17.3286 13.1729 17.3631L13.7806 18.3489H13.1007ZM12.4063 16.9881H12.7896C12.8875 16.9954 12.9845 16.9655 13.0607 16.9048C13.0909 16.8735 13.1141 16.8364 13.1287 16.7957C13.1433 16.7551 13.1491 16.7119 13.1457 16.669C13.1485 16.6263 13.1425 16.5836 13.1278 16.5433C13.1132 16.5031 13.0904 16.4662 13.0607 16.4348C12.9856 16.3734 12.8888 16.3435 12.7913 16.3515H12.408L12.4063 16.9881Z"
					fill="#F3F3F6" />
				<path d="M14.657 17.8844H15.4849V18.3485H14.0399V15.8428H14.6587L14.657 17.8844Z" fill="#F3F3F6" />
				<path
					d="M10.7604 15.8428H11.4355V17.436C11.4355 17.6254 11.3902 17.7894 11.2995 17.9278C11.2097 18.0654 11.0842 18.1719 10.9231 18.2472C10.762 18.3216 10.575 18.3589 10.362 18.3589C10.1475 18.3589 9.9597 18.3216 9.7986 18.2472C9.63749 18.1719 9.51201 18.0654 9.42215 17.9278C9.3331 17.7894 9.28857 17.6254 9.28857 17.436V15.8428H9.96375V17.3777C9.96375 17.4546 9.98075 17.5234 10.0147 17.5841C10.0488 17.644 10.0957 17.691 10.1556 17.725C10.2163 17.759 10.2851 17.776 10.362 17.776C10.4398 17.776 10.5086 17.759 10.5685 17.725C10.6284 17.691 10.6753 17.644 10.7094 17.5841C10.7434 17.5234 10.7604 17.4546 10.7604 17.3777V15.8428Z"
					fill="#F3F3F6" />
				<path d="M9.00882 17.7678V18.3737H8.36877V17.7678H9.00882Z" fill="#F3F3F6" />
			</g>
			<defs>
				<clipPath id="clip0_66_353">
					<rect width="20" height="20" fill="white" transform="translate(0.106201)" />
				</clipPath>
			</defs>
		</svg>

	</div>
</template>

<style scoped>

</style>